import { createContext } from 'react';
import { ApolloError } from '@apollo/client';

import { CreditProductPurchaseOrderForAfterPayment } from '../../types';

export type OpenModalOptions = {
  callback?: () => void;
  errorBannerProviderInitialValue?: ApolloError;
  onClose?: (
    creditProductPurchaseOrder?: CreditProductPurchaseOrderForAfterPayment
  ) => void;
};

type ContactPacksPurchaseModalContext = {
  openContactPacksPurchaseModal: (options?: OpenModalOptions) => void;
  isModalChunkLoadPending: boolean;
};

export const ContactPacksPurchaseModalContext = createContext<
  ContactPacksPurchaseModalContext | undefined
>(undefined);
